// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__2FAZ7","title":"ClientInsurance_title__6u1fT","itemText":"ClientInsurance_itemText__1vvBK"};